import React from "react";

const ITEMS = [
  {
    type: "img",
    src: "https://images.pexels.com/photos/12698667/pexels-photo-12698667.jpeg",
    label: "WORKSHOP · LIVE",
    title: "Quality",
  },
  {
    type: "stat",
    big: "0.1",
    unit: "MM",
    label: "Minimum FDM layer height",
  },
  {
    type: "img",
    src: "https://images.pexels.com/photos/15208335/pexels-photo-15208335.jpeg",
    label: "POST · WORKSHOP",
    title: "Finishing in progress",
  },
  {
    type: "img",
    src: "https://images.pexels.com/photos/20688553/pexels-photo-20688553.jpeg",
    label: "PLA · ORANGE",
    title: "Functional prototype",
  },
  {
    type: "text",
    title: "EVERY JOB",
    body: "Inspected, calibrated, then re-inspected. We don't ship parts we wouldn't keep on our own desk.",
  },
  {
    type: "img",
    src: "https://customer-assets.emergentagent.com/job_toad-factory/artifacts/laoqh79n_PXL_20260110_030301458.jpg",
    label: "BED · IN PROGRESS",
    title: "Millennium Falcon",
  },
];

export const Gallery = () => {
  return (
    <section
      id="work"
      data-testid="gallery-section"
      className="relative py-24 md:py-32 border-b border-[#2A2A2A] bg-[#0A0A0A]"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-12 border-b border-white/10 pb-8 gap-4">
          <div>
            <p className="overline mb-4">// 04 — Selected work</p>
            <h2
              className="font-display uppercase leading-[0.9] text-white"
              style={{ fontSize: "clamp(2.5rem, 7vw, 6rem)" }}
              data-testid="gallery-headline"
            >
              From the<br />
              <span className="text-[#FF5722]">workshop floor.</span>
            </h2>
          </div>
          <a
            href="#quote"
            className="font-mono-ui text-[11px] tracking-[0.25em] uppercase text-white/70 hover:text-[#FF5722] border-b border-white/20 hover:border-[#FF5722] pb-1 self-start"
          >
            Got a project? →
          </a>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-6 grid-flow-dense gap-px bg-[#2A2A2A] border border-[#2A2A2A]">
          {/* Cell 1 - large video */}
          <div className="col-span-2 md:col-span-3 row-span-2 relative overflow-hidden bg-[#0F0F0F] aspect-square md:aspect-auto md:min-h-[420px] group">
            <video
              src="https://customer-assets.emergentagent.com/job_toad-factory/artifacts/itak8o79_eb4299a8f9d1ab646597a9196e22ddc2~2.mp4"
              className="w-full h-full object-cover"
              autoPlay
              loop
              muted
              playsInline
              data-testid="gallery-video"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-6 flex items-end justify-between">
              <div>
                <p className="font-mono-ui text-[10px] tracking-[0.3em] text-[#FF5722] mb-1">{ITEMS[0].label}</p>
                <h3 className="font-display text-white text-2xl uppercase leading-none">{ITEMS[0].title}</h3>
              </div>
            </div>
          </div>

          {/* Cell 2 - video */}
          <div className="col-span-2 md:col-span-2 relative overflow-hidden bg-[#0F0F0F] min-h-[210px]" data-testid="gallery-logo-tile">
            <video
              src="https://customer-assets.emergentagent.com/job_toad-factory/artifacts/lvmejiod_Snapchat-691688194.mp4"
              className="w-full h-full object-cover"
              autoPlay
              loop
              muted
              playsInline
            />
          </div>

          {/* Cell 3 - image */}
          <div className="col-span-2 md:col-span-1 relative bg-[#0F0F0F] min-h-[210px] group overflow-hidden">
            <img src={ITEMS[2].src} alt={ITEMS[2].title} className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition duration-700" />
            <div className="absolute inset-0 bg-black/40" />
            <p className="absolute bottom-3 left-3 font-mono-ui text-[9px] tracking-[0.25em] text-white">{ITEMS[2].label}</p>
          </div>

          {/* Cell 4 - image */}
          <div className="col-span-2 md:col-span-2 relative bg-[#0F0F0F] min-h-[260px] group overflow-hidden">
            <img src={ITEMS[3].src} alt={ITEMS[3].title} className="w-full h-full object-cover group-hover:scale-105 transition duration-700" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent" />
            <div className="absolute bottom-4 left-4">
              <p className="font-mono-ui text-[10px] tracking-[0.3em] text-[#FF5722]">{ITEMS[3].label}</p>
              <h3 className="font-display text-white text-xl uppercase leading-none">{ITEMS[3].title}</h3>
            </div>
          </div>

          {/* Cell 5 - text */}
          <div className="col-span-2 md:col-span-2 bg-[#0F0F0F] p-8 flex flex-col justify-between min-h-[260px]">
            <p className="font-mono-ui text-[10px] tracking-[0.3em] text-white/40 uppercase">// QC</p>
            <div>
              <h3 className="font-display text-white uppercase text-3xl leading-none mb-3">{ITEMS[4].title}</h3>
              <p className="font-body text-white/60 text-sm">{ITEMS[4].body}</p>
            </div>
          </div>

          {/* Cell 6 - image wide */}
          <div className="col-span-2 md:col-span-2 relative bg-[#0F0F0F] min-h-[260px] group overflow-hidden">
            <img src={ITEMS[5].src} alt={ITEMS[5].title} className="w-full h-full object-cover group-hover:scale-105 transition duration-700" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent" />
            <div className="absolute bottom-4 left-4">
              <p className="font-mono-ui text-[10px] tracking-[0.3em] text-[#FF5722]">{ITEMS[5].label}</p>
              <h3 className="font-display text-white text-xl uppercase leading-none">{ITEMS[5].title}</h3>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Gallery;
